/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EvmInternalTraceGroupInfo } from '../models/EvmInternalTraceGroupInfo';
import type { EvmInternalTrxGroupListInfo } from '../models/EvmInternalTrxGroupListInfo';
import type { EvmLogsInfo } from '../models/EvmLogsInfo';
import type { EvmTrxDetailInfo } from '../models/EvmTrxDetailInfo';
import type { EvmTrxListInfo } from '../models/EvmTrxListInfo';
import type { EvmTrxPendingListInfo } from '../models/EvmTrxPendingListInfo';
import type { EvmTrxSummaryInfo } from '../models/EvmTrxSummaryInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EvmTrxControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns EvmTrxSummaryInfo OK
     * @throws ApiError
     */
    public getEvmTransactionSummaryList({
        size = 10,
    }: {
        size?: number,
    }): CancelablePromise<Array<EvmTrxSummaryInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/transaction/summary',
            query: {
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTrxSummaryInfo OK
     * @throws ApiError
     */
    public getEvmTransactionSummaryList1({
        size = 10,
    }: {
        size?: number,
    }): CancelablePromise<Array<EvmTrxSummaryInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/transaction/summary',
            query: {
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTrxListInfo OK
     * @throws ApiError
     */
    public getEvmTransactionScrollList({
        size = 25,
        lastVal,
    }: {
        size?: number,
        lastVal?: number,
    }): CancelablePromise<EvmTrxListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/transaction/scroll/list',
            query: {
                'size': size,
                'lastVal': lastVal,
            },
        });
    }

    /**
     * @returns EvmTrxListInfo OK
     * @throws ApiError
     */
    public getEvmTransactionScrollList1({
        size = 25,
        lastVal,
    }: {
        size?: number,
        lastVal?: number,
    }): CancelablePromise<EvmTrxListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/transaction/scroll/list',
            query: {
                'size': size,
                'lastVal': lastVal,
            },
        });
    }

    /**
     * @returns EvmTrxPendingListInfo OK
     * @throws ApiError
     */
    public getEvmTransactionPendingList({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTrxPendingListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/transaction/pending/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTrxPendingListInfo OK
     * @throws ApiError
     */
    public getEvmTransactionPendingList1({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTrxPendingListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/transaction/pending/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmLogsInfo OK
     * @throws ApiError
     */
    public getEvmTransactionLogList({
        trxHash,
    }: {
        trxHash: string,
    }): CancelablePromise<Array<EvmLogsInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/transaction/log/list',
            query: {
                'trxHash': trxHash,
            },
        });
    }

    /**
     * @returns EvmLogsInfo OK
     * @throws ApiError
     */
    public getEvmTransactionLogList1({
        trxHash,
    }: {
        trxHash: string,
    }): CancelablePromise<Array<EvmLogsInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/transaction/log/list',
            query: {
                'trxHash': trxHash,
            },
        });
    }

    /**
     * @returns EvmTrxListInfo OK
     * @throws ApiError
     */
    public getEvmTransactionList({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTrxListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/transaction/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTrxListInfo OK
     * @throws ApiError
     */
    public getEvmTransactionList1({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTrxListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/transaction/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmInternalTraceGroupInfo OK
     * @throws ApiError
     */
    public getEvmInternalTraceByHash({
        trxHash,
    }: {
        trxHash: string,
    }): CancelablePromise<Array<EvmInternalTraceGroupInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/transaction/internal/trace',
            query: {
                'trxHash': trxHash,
            },
        });
    }

    /**
     * @returns EvmInternalTraceGroupInfo OK
     * @throws ApiError
     */
    public getEvmInternalTraceByHash1({
        trxHash,
    }: {
        trxHash: string,
    }): CancelablePromise<Array<EvmInternalTraceGroupInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/transaction/internal/trace',
            query: {
                'trxHash': trxHash,
            },
        });
    }

    /**
     * @returns EvmInternalTrxGroupListInfo OK
     * @throws ApiError
     */
    public getEvmInternalTransactionList({
        page = 1,
        size = 15,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EvmInternalTrxGroupListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/transaction/internal/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmInternalTrxGroupListInfo OK
     * @throws ApiError
     */
    public getEvmInternalTransactionList1({
        page = 1,
        size = 15,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EvmInternalTrxGroupListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/transaction/internal/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTrxDetailInfo OK
     * @throws ApiError
     */
    public getEvmTransactionDetail({
        trxHash,
    }: {
        trxHash: string,
    }): CancelablePromise<EvmTrxDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/transaction',
            query: {
                'trxHash': trxHash,
            },
        });
    }

    /**
     * @returns EvmTrxDetailInfo OK
     * @throws ApiError
     */
    public getEvmTransactionDetail1({
        trxHash,
    }: {
        trxHash: string,
    }): CancelablePromise<EvmTrxDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/transaction',
            query: {
                'trxHash': trxHash,
            },
        });
    }

}
